import common from './common.json'
import error from './error.json'
import resume from './resume.json'
import banner from './banner.json'
import portfolio from './portfolio.json'

export default {
  ...common,
  ...error,
  ...resume,
  ...banner,
  ...portfolio,
}
